<template>
    <div id="notes-modal" class="text-center">
        <div>
            <button type="button" class="close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6 class="mt-3 mb-3 ml-2 mr-2">{{heading}}</h6>
        </div>
        <div style="overflow-y: scroll; max-height: 480px; margin-bottom: 15px;">
            <table style="margin: 10px;">
                <tbody v-if="$store.getters.getNotes.length">
                <tr v-for="(note,index) in $store.getters.getNotes" :key="index">
                    <td class="note border-radius-left"
                    ><span style="font-weight: bold">{{$moment(note.date_time).format('YYYY-MM-DD hh:mm')}}</span> {{note.text}}
                    </td>
                    <td class="note border-radius-right">
                  <span @click="deleteNote(note.id)"><i style="font-size: 1.1em; cursor: pointer;"
                                                        class="fa fa-trash"></i></span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <label>{{$t('message.addaNewNote')}}:</label>
        <div class="form-group" style="display: flex; justify-content: center; align-items: center;">
            <textarea v-model="addNote.text" :placeholder="$t('message.text')" class="form-control" style="width: 680px"
                      rows="3" cols="40">
            </textarea>
        </div>
        <div style="margin-bottom: 10px">
            <button @click="addaNote" class="btn btn-primary">{{$t('message.add')}}</button>
        </div>
        <div>
            <button @click="closeModal" class="btn btn-primary btn-block">OK</button>
        </div>
    </div>
</template>

<script>
  import OkModal     from './OkModal'
  import DialogModal from './DialogModal'

  export default {
    name: 'NotesModal',
    data () {
      return {
        idForDelete: null,
        addNote: {
          sheet_id: null,
          text: null
        }
      }
    },
    props: ['heading', 'sheetId'],
    created () {
      this.addNote.sheet = this.sheetId
      this.getTheListOfNotes()
    },
    methods: {
      confirmDeleteNote (id) {
        this.delete(this.apiPrefix, this.noteApiUrl + '/', id)
          .then(() => {
            this.getTheListOfNotes()
            this.$modal.show(OkModal, {
                text: `${this.$t('message.note')} ${this.$t('message.succesfullyDeleted')}.`,
                modalClass: this.modalClasses.okSuccessClass
              },
              {
                width: this.modalWidth(),
                height: 'auto'
              })
          })
          .catch(err => {
            console.log(err)
          })
      },
      deleteNote (id) {

        this.idForDelete = id

        this.$modal.show(DialogModal, {
            text: `${this.$t('message.confirmDelete')} ${this.$t('message.this')} ${this.$t('message.note')}?`,
            param: id,
            textColor: '#e74c3c',
            event: 'deleteNote'
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })
      },
      getTheListOfNotes () {
        this.getList(this.apiPrefix, this.noteApiUrl,
          `?sheet_id=${this.addNote.sheet}`)
          .then(resp => {
            this.$store.commit('setNotes', resp.data)
          })
          .catch()
      },
      addaNote () {
        this.post(this.apiPrefix, this.noteApiUrl + '/', '', this.addNote).then(() => {
          this.getTheListOfNotes()
          this.addNote.text = ''

          this.$modal.show(OkModal, {
              text: `${this.$t('message.note')} ${this.$t('message.succesfullyAdded')}.`,
              modalClass: this.modalClasses.okSuccessClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
           this.$emit('addNote')
        }).catch(err => {
          let msg = this.createErrorMessage(this.parseErrors(err.response.data.errors))

          this.$modal.show(OkModal, {
              text: msg,
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        })
      },
      closeModal () {
        this.$emit('close')
      },
    }
  }
</script>

<style scoped>
    .close {
        margin-right: 10px;
        margin-top: -5px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0 1em;
    }

    .note {
        background: #f9eeae;
        padding: 5px;
    }

    .border-radius-left {
        border-top-left-radius: 10px;
    }

    .border-radius-right {
        border-bottom-right-radius: 10px;
    }

    .background-red {
        background: #f74c4c
    }


</style>